import React from 'react';
import { PitchDeck } from './components/PitchDeck';
export function App() {
  return <PitchDeck data-id="element-0" data-mp="35ckcmdszdem5" />;
}